import React, { useEffect, useState, useRef } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../../../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../../../elements/RenderErrors';
import InputTextArea from '../../../elements/InputTextArea';
import ButtonGroupSelection from '../../../elements/ButtonGroupSelection';
import store from '../../../../services/store';
import helpers from '../../../../services/helpers';
import { getApiData } from '../../../../services/apiService';
import QRScannerComponent from '../../../parts/QRScannerComponent';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
 
export default function BoardingPreview ({
        reference_id = '', 
        is_show = false, 
        setShow, 
        handleSave, 
        header_title="Onboard Vehicle",
        store_id="",
        index="",
        member_data={},
        direct_save,

        
        handleResult, 
    }){
    let default_data = {
        "id": "",
        "name":"",
        "voyage_no": "",
        "registry_no": "",
        "max_passenger_qty": "",
        "max_vehicle_qty": "",
        "max_deadweight_tonnage": "",
    }
    const toast = useRef(null);
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');
    const [form_data, setFormData] = useState(default_data);
    const [form_loaded, setFormLoaded] = useState(0);
    const [errors, setErrors] = useState([]);

    const [scannedData, setScannedData] = useState(null);
    const [showScanner, setShowScanner] = useState(true);
    const [scanError, setScanError] = useState(null);
   
    useEffect(() => {
        setErrors([])

        if(is_show && reference_id){
            fetchData()
        }
        else if(is_show){
            setFormData(default_data)
        }
    }, [is_show]);
   
    useEffect(() => {
        setErrors([])
    }, [form_data]);
    

    function fetchData(){
        if(!reference_id){
            return
        }
        const url = helpers.createShipBookingHubUrl(`booking/manifest/${reference_id}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setFormData(res)
            setLoading(0)
            setFormLoaded(1)
        })
        .catch((err) => {
            setLoading(0)
            setFormLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                }
            })
        }); 
    }
    
    function inputChange(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        setFormData({ ...form_data, ...new_state });
    }

    function validateForm(){
        let new_errors = {...errors}
        let variant_errors = 0;

        if(!form_data.name){
            new_errors['name'] = ['The name field is required.']
        }
        else{
            delete new_errors['name'];
        }

        if(!form_data.relationship){
            new_errors['relationship'] = ['The relationship field is required.']
        }
        else{
            delete new_errors['relationship'];
        }

        if(!form_data.gender){
            new_errors['gender'] = ['The gender field is required.']
        }
        else{
            delete new_errors['gender'];
        }

        if(form_data.age === null || form_data.age === undefined || form_data.age === ""){
            new_errors['age'] = ['The age field is required.']
        }
        else{
            delete new_errors['age'];
        }

        setErrors(new_errors);

        return new_errors;
    }

    // function handleSubmit(e) {
    //     // const validate = validateForm();
    //     // if(Object.keys(validate).length){
    //     //     toast.current.show({severity:'error', detail:'Please complete all required fields in the form.', life: 5000});
    //     //     return
    //     // }

    //     setShow(0);
    //     let form_data = {...form_data}
    //     if(reference_id){
    //         form_data.flag = 'edit'
    //     }

    //     handleSave(form_data, index)
        
    // }



    function handleSubmit(e) {
        handleSave(form_data)
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setFormData([])
        setNotice('')
    }

    const footerContent = (
        <div>
            <Button label="Proceed" className='rounded' icon="fas fa-check" onClick={(e) => handleSubmit(1)} autoFocus />
        </div>
    );

    return (
        <>
            <Toast ref={toast} position="top-center" />
            <Dialog 
                visible={is_show} 
                position="top" 
                header={header_title} 
                style={{ width: '70vw' }} 
                breakpoints={{ 
                    '960px': '75vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                footer={footerContent}
            >
                <Loader isLoading={loading}/>
                <div className="row mt-2">
                    <div className="col-md-6 col-lg-3 form-group">
                        <label>Booking Ref</label>
                        <InputText
                            value={form_data.booking_ref}
                            tagClass="mb-0"
                            placeholder="Reference"
                            className='w-100'
                            readOnly={true}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3 form-group">
                        <label>Departure Date/Time</label>
                        <InputText
                            value={helpers.formatManifestDateTime(form_data.departure_time)}
                            tagClass="mb-0"
                            placeholder="Departure Date/Time"
                            className='w-100'
                            readOnly={true}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3 form-group">
                        <label>Booking Date</label>
                        <InputText
                            value={form_data.booking_date}
                            tagClass="mb-0"
                            placeholder="Booking Date"
                            className='w-100'
                            readOnly={true}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <label>Customer</label>
                        <InputText
                            value={form_data.customer_name}
                            tagClass="mb-0"
                            placeholder="Customer"
                            className='w-100'
                            readOnly={true}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3 form-group">
                        <label>Plate Number</label>
                        <InputText
                            value={form_data.plate_number}
                            tagClass="mb-0"
                            placeholder="Plate Number"
                            className='w-100'
                            readOnly={true}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3 form-group">
                        <label>Brand</label>
                        <InputText
                            value={form_data.brand}
                            tagClass="mb-0"
                            placeholder="Brand"
                            className='w-100'
                            readOnly={true}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3 form-group">
                        <label>Model</label>
                        <InputText
                            value={form_data.model_name}
                            tagClass="mb-0"
                            placeholder="Model"
                            className='w-100'
                            readOnly={true}
                        />
                    </div>
                    <div className="col-md-6 col-lg-3 form-group">
                        <label>Driver(s)</label>
                        <InputText
                            value={form_data.driver}
                            tagClass="mb-0"
                            placeholder="Driver(s)"
                            className='w-100'
                            readOnly={true}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    )
}